import React, { useEffect, useState } from "react";
import loadConfig from "../../../Services/Api/ApiServices";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import {
  GetOneAC_NT_CM_Commitment,
  setCommitment,
} from "../../../Redux/Reducers/Submitter/Commitment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router-dom";
function Pledge(props) {
  const dispatch = useDispatch();
  const [appInfo, setAppInfo] = useState();
  const AttachmentsAnswerList = useSelector(
    (state) => state.AttachmentsAnswer.ValidationAttachments
  );
 const {ApplicationInformationId} = useParams();
  var AttachmentsAnswerListResult =
    AttachmentsAnswerList?.length > 0
      ? AttachmentsAnswerList[0].list.map((x) => x.code)
      : null;
  console.log(AttachmentsAnswerListResult, "ssssssdwwd");

  const lang = useSelector((state) => state.languageReducer.Language);
  const Commitment = useSelector((state) => state.Commitment.Commitment);

  const getData = async () => {
    const data = await dispatch(
      GetOneAC_NT_CM_Commitment({
        applicationInformationId: localStorage.getItem(
          "ApplicationInformationId"
        )||
          ApplicationInformationId,
      })
    );

    if (data.payload) {
      setAppInfo({ ...data.payload });
    }
  };
  useEffect(() => {
    getData();
  }, [ApplicationInformationId]);

  useEffect(() => {
    dispatch(setCommitment({ ...appInfo }));
  }, [appInfo]);

  const [jsonFile, setJsonFile] = useState();
  const dataJson = async () => {
    let jsonData = await loadConfig();
    setJsonFile(jsonData);
  };
  useEffect(() => {
    dataJson();
  }, []);
  return (
    <div
      className="checkbox-container"
      key="checkbox"
      dir={lang === "ar" ? "rtl" : "ltr"}
    >
      <label className="checkbox-label">
        <input
          type="checkbox"
          className={`${
            AttachmentsAnswerListResult &&
            AttachmentsAnswerListResult.includes("Pledge")
              ? "input-error"
              : ""
          } checkbox-input`}
          disabled={props.disabled}
          checked={Commitment.commitmentConfirmed}
          onChange={(e) => {
            setAppInfo({
              ...appInfo,
              commitmentConfirmed: e.target.checked,
            });
          }}
        />

        {lang === "ar" ? jsonFile?.Pledge?.nameAR : jsonFile?.Pledge?.nameEN}
        {AttachmentsAnswerListResult &&
          AttachmentsAnswerListResult.includes("Pledge") && (
            <span
              style={{ marginTop: "20px" }}
              className="validation-icon"
              data-tooltip={lang == "ar" ? "حقل اجباري " : "Field Required"}
            >
              <FontAwesomeIcon icon={faCircleExclamation} />
              &nbsp;
            </span>
          )}
      </label>
    </div>
  );
}

export default Pledge;
